import React, { useState, useEffect, useRef } from 'react';
import styles from 'componets/export-button/index.module.scss';
import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';
import classname from 'classnames/bind';
import { DownloadIcon, CloseIcon, SendIcon, InfoCircleFillIcon, CloseCircleFillIcon, CheckIcon } from 'icons';
import { errorHandler } from 'helpers/error-handler';
import LoadingIcon from 'componets/button/loading-icon';
import UseDevice, { DEVICE_MOBILE } from 'hooks/use-device';

export const STATE_EXPORT_INIT = 'STATE_EXPORT_INIT';
export const STATE_EXPORT_DISABLE = 'STATE_EXPORT_DISABLE';
export const STATE_EXPORT_LOADING = 'STATE_EXPORT_LOADING';
export const STATE_EXPORT_ERROR = 'STATE_EXPORT_ERROR';
export const STATE_EXPORT_DONE = 'STATE_EXPORT_DONE';

const cx = classname.bind(styles);

const ExportButton = ({ title, email, filterContent, state, error, onExport, onShowDropdown }) => {
  const [showPopup, setShowPopup] = useState(false);
  const popUpRef = useRef();
  const device = UseDevice();

  useEffect(() => {
    if (device !== DEVICE_MOBILE) return;

    if (state.showPopup) {
      disableBodyScroll(popUpRef.current);
    } else {
      enableBodyScroll(popUpRef.current);
    }
    return () => {
      clearAllBodyScrollLocks();
    };
  }, [device, state.showPopup]);

  const maskClasses = cx({
    mask: true,
    visible: showPopup,
  });

  const popupClasses = cx({
    popup: true,
    show: showPopup,
  });

  const buttonClasses = cx({
    button: true,
    disable: state === STATE_EXPORT_DISABLE,
  });

  const togglePopup = () => {
    const show = !showPopup;
    setShowPopup(show);
    if (show && onShowDropdown) {
      onShowDropdown();
    }
  };

  const ErrorMessage = () => {
    if (state === STATE_EXPORT_DISABLE) {
      return (
        <div className={styles.disable}>
          <InfoCircleFillIcon />
          請篩選欲匯出日期，並以一個月為上限。
        </div>
      );
    } else if (error) {
      return (
        <div className={styles.error}>
          <CloseCircleFillIcon />
          {errorHandler(error)}
        </div>
      );
    } else return <></>;
  };

  const ButtonText = () => {
    switch (state) {
      case STATE_EXPORT_LOADING:
        return <LoadingIcon />;
      case STATE_EXPORT_DONE:
        return (
          <>
            <CheckIcon width={16} height={16} />
            已寄送
          </>
        );
      default:
        return (
          <>
            <SendIcon width={16} height={16} />
            寄送
          </>
        );
    }
  };

  const FilterItem = () => {
    if (filterContent.length > 0) {
      return (
        <>
          <div style={{ height: '26px' }} />
          <span className={styles.label}>已篩選</span>
          <div className={styles.text}>
            {filterContent.map(x => {
              if (x.includes('類別')) return <div className={styles.catag}>{x}</div>;
              return <div>{x}</div>;
            })}
          </div>
        </>
      );
    } else {
      return <></>;
    }
  };

  return (
    <div className={styles.exportButton}>
      <div className={styles.button} onClick={togglePopup}>
        <DownloadIcon className={styles.icon} width={20} height={20} />
        匯出
      </div>
      <div className={maskClasses} onClick={togglePopup} />
      <div className={popupClasses} ref={popUpRef}>
        <div className={styles.popUpMenu}>
          <div className={styles.head}>
            <div className={styles.title}>{title}</div>
            <CloseIcon className={styles.close} onClick={togglePopup} />
          </div>
          <div className={styles.form}>
            <span className={styles.label}>寄送信箱</span>
            <div className={styles.text}>{email}</div>
            <FilterItem />
            <ErrorMessage />
          </div>
          <div className={buttonClasses} onClick={onExport}>
            <ButtonText />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExportButton;
